import { render, staticRenderFns } from "./JourneySummaryAlt.vue?vue&type=template&id=9fe7e2ec&"
import script from "./JourneySummaryAlt.vue?vue&type=script&lang=js&"
export * from "./JourneySummaryAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports